import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Uygulama başladığında token varsa kullanıcıyı doğrula
  useEffect(() => {
    const token = localStorage.getItem('cari_token');
    const savedUser = localStorage.getItem('cari_user');

    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem('cari_token');
        localStorage.removeItem('cari_user');
      }
    }
    setIsLoading(false);
  }, []);

  const login = useCallback(async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    const { token, user: userData } = response.data;

    localStorage.setItem('cari_token', token);
    localStorage.setItem('cari_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('cari_token');
    localStorage.removeItem('cari_user');
    setUser(null);
  }, []);

  // Admin kontrolü
  const isAdmin = user?.role === 'admin';

  // Granüler izin kontrolü — admin her şeye erişebilir
  const hasPermission = useCallback((permKey) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return user.permissions?.[permKey] === true;
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, isAdmin, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth, AuthProvider içinde kullanılmalıdır');
  return ctx;
}
